












































































































































































































































































































































































import {
  defineComponent, reactive, ref, Ref, onMounted, watch, computed,
} from '@vue/composition-api';
import { debounce } from 'lodash';
import { useRouter, useFormat } from '@ideavivat/vivat-2';

import {
  createPurchaseOrder,
  getPurchaseRequest,
  getPurchaseRequests,
  getPurchaseRequestItems,
  getPurchaseRequestMiscItems,
  searchPurchaseRequestItems,
  getSuppliers,
  getMaterials,
  checkExistingPurchaseOrderCode,
} from '@/api/index';

import purchaseOrderItems from '@/table/PurchaseOrder/create-purchase-order-item';
import purchaseOrderMiscItems from '@/table/PurchaseOrder/create-purchase-order-misc-item';
import purchaseOrderItemWithAmountTableOption from '@/table/PurchaseOrder/create-purchase-order-item-with-amount';
import purchaseOrderMiscItemWithAmountTableOption from '@/table/PurchaseOrder/create-purchase-order-misc-item-with-amount';
import useDownloadReport from '@/use/useDownloadReport';
import usePurchaseRequest from '@/use/usePurchaseRequest';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import StickyFooterActionBar from '@/components/StickyFooterActionBar.vue';

const NOW = useFormat.date().computerShortDate();
const TOMORROW = useFormat.date(useFormat.date().dayjs.add(1, 'day')).computerShortDate();

const PanelWithMaterialPurchaseRequestEditor = defineComponent({
  components: {
    CommonModalWithPreset,
    StickyFooterActionBar,
  },
  props: {
    edit: { default: false },
    title: { default: '' },
  },
  setup(props) {
    const { route, router } = useRouter();
    const toDate = (date: string): string => useFormat.date(date).displayFullThaiDate();
    const { typeTranslate } = usePurchaseRequest();
    const { getPreview } = useDownloadReport();
    const step = ref(1);
    const refetchQuery = ref(false);
    const confirmModal = ref(null);
    const purchaseRequest = ref({
      id: -1,
      itemsType: 'MATERIALS',
      subType: 'DEFAULT',
    });
    const selectedPurchaseRequests: Ref<any[]> = ref([]);
    const computedPurchaseRequestSelectorVariables = computed(() => {
      const vars = {
        itemsType: purchaseRequest.value.itemsType,
        subType: purchaseRequest.value.subType,
        approved: true,
        status: 'PENDING',
      };
      return vars;
    });
    const computedSelectedPurchaseRequestIds = computed(() => selectedPurchaseRequests.value.map((elm: any) => elm.id));
    const search = reactive({
      filterMaterial: '',
      filterBomItem: '',
    });

    const getSuppliersResult = (data: any) => data.data.data;
    const purchaseRequestTableData = ref({ total: 0, data: [] });
    const forceRender = ref(false);
    const form = reactive({
      id: -1,
      // Temporary field, for migrate to new system,
      code: undefined,
      createdAt: NOW,
      // End temporary field
      supplierId: -1,
      supplier: null,
      type: '',
      status: 'PENDING',
      remarks: '',
      targetDate: TOMORROW,
      items: [],
      miscItems: [],
      discount: 0,
      vatType: 'EX',
      supplierRemarks: '',
      customer_po: '',
      job_no: '',
      job_name: '',
      quotation_no: '',
      command: '',
      command_unit: '',
      command_quantity: 0,
      command_unit_price: 0,
      call: async () => {
        if (props.edit) console.log('TO DO');
        else {
          await createPurchaseOrder(computedPurchaseOrderInput.value);
        }
        (confirmModal.value as any).compose({ action: 'บันทึก', entity: 'ใบสั่งซื้อ' });
      },
      state: {
        value: 'READY',
      },
    });
    const computedPurchaseOrderInput = computed(() => ({
      supplierId: (form.supplier as any)?.id,
      // Temporary field, for migrate to new system,
      code: form.code !== '' && form.code ? form.code : undefined,
      createdAt: form.createdAt && form.createdAt !== '' ? form.createdAt : undefined,
      // End temporary field
      type: purchaseRequest.value.itemsType,
      status: form.status,
      remarks: form.remarks,
      purchaseRequestId: route.value.params.prId,
      creditDays: (form.supplier as any).credit_days || 0,
      supplierRemarks: form.supplierRemarks,
      customer_po: form.customer_po,
      job_no: form.job_no,
      job_name: form.job_name,
      quotation_no: form.quotation_no,
      miscItems: form.miscItems.map((item: any) => ({
        purchaseRequestMiscItemId: item.id,
        description: item.description,
        unit: item.unit,
        targetDate: form.targetDate,
        amount: parseFloat(item?.amount),
        pricePerUnit: parseFloat(item.pricePerUnit),
      })).filter((item: any) => item.amount > 0),
      items: form.items.map((item: any) => ({
        purchaseRequestItemId: item.id,
        materialId: item.material.id,
        bomItemId: item.bom_item_id,
        unit: item.unit,
        targetDate: form.targetDate,
        purchaseUnit: item.purchaseUnit,
        amount: parseFloat(item?.amount),
        pricePerUnit: parseFloat(item.pricePerUnit || '0'),
        amountPerUnit: parseFloat(item.amountPerUnit),
      })).filter((item: any) => item.amount > 0),

      vat: computedPurchaseOrderPrice.value.totalVat,
      vatType: form.vatType,
      subType: purchaseRequest.value.subType,
      discount: form.discount,

      command: form.command,
      command_quantity: form.command_quantity,
      command_unit: form.command_unit,
      command_unit_price: form.command_unit_price,
    }));

    // Use to find bom item where has bom id
    const filter = computed(() => ({
      filterPrIds: computedSelectedPurchaseRequestIds.value.length > 0 ? computedSelectedPurchaseRequestIds.value : undefined,
      filterMaterial: search.filterMaterial !== '' ? `${search.filterMaterial}` : undefined,
      filterBomItem: search.filterBomItem !== '' ? `${search.filterBomItem}` : undefined,
      filterPrStatus: ['PENDING', 'DONE'],
      approved: true,
    }));

    function assignPurchaseRequestToSelectedArrays() {
      // eslint-disable-next-line
      const condition = computedSelectedPurchaseRequestIds.value.find((elm: any) => elm == purchaseRequest.value.id);
      if (!condition && purchaseRequest.value.id !== -1) {
        selectedPurchaseRequests.value.push(purchaseRequest.value as any);
      }
    }
    async function getPurchaseRequestData() {
      purchaseRequest.value = (await getPurchaseRequest(route.value.params.prId)).data;
      assignPurchaseRequestToSelectedArrays();
    }
    onMounted(async () => {
      if (route.value.params.prId) await getPurchaseRequestData();
    });
    const computedTableInformation = computed(() => {
      if (purchaseRequest.value.itemsType === 'MATERIALS') {
        return {
          type: 'purchase_request_items',
          query: getPurchaseRequestItems,
          option: purchaseOrderItems,
          data: form.items,
          amountTable: purchaseOrderItemWithAmountTableOption,
        };
      }
      return {
        type: 'purchase_request_misc_items',
        query: getPurchaseRequestMiscItems,
        option: purchaseOrderMiscItems,
        data: form.miscItems,
        amountTable: purchaseOrderMiscItemWithAmountTableOption,
      };
    });
    const computedPurchaseOrderPrice = computed(() => {
      let price = 0;
      let key = 'miscItems';
      if (purchaseRequest.value.itemsType === 'MATERIALS') key = 'items';
      (form as any)[key].forEach((item: any) => {
        price += parseFloat(item.pricePerUnit || 0) * parseFloat(item.amount || 0);
      });
      price += (form.command_unit_price * form.command_quantity) || 0;

      const vat = 7;
      let totalVat = 0;
      const priceAfterDiscount = price - form.discount > -1 ? price - form.discount : 0;
      let totalPrice = priceAfterDiscount;
      if (form.vatType === 'IN') {
        const beforeVat = ((priceAfterDiscount / (100 + vat)) * 100);
        totalVat = priceAfterDiscount - beforeVat;
      } else if (form.vatType === 'EX') {
        totalVat = (totalPrice * vat) / 100;
        totalPrice = priceAfterDiscount + totalVat;
      }

      return {
        totalPrice, totalVat, priceAfterDiscount, price,
      };
    });
    const computedSupplierAddress = computed(() => {
      if (!(form.supplier) || !(form.supplier as any).province_id) return '';
      if (!(form.supplier as any).district_id) return '';
      if (!(form.supplier as any).subdistrict_id) return '';
      const key = (form.supplier as any)?.show_as_english ? 'name_in_english' : 'name_in_thai';
      const subDistrict = (form.supplier as any).sub_district[key] !== 'NULL' ? (form.supplier as any).sub_district[key] : (form.supplier as any).sub_district.name_in_thai;
      return `${(form.supplier as any).address}${key === 'name_in_english' && (form.supplier as any).province_id !== 1 ? ' Tumbol ' : ' '}${subDistrict} ${(form.supplier as any).district[key]} ${(form.supplier as any).province[key]} ${(form.supplier as any).zipcode}`;
    });

    // Use to store which item already select
    const selectedItemId: Ref<number[]> = ref([]);
    // Use to finallize value that send to search api (Search api for find whole item that user choose to create PR)
    const searchValue: Ref<string | number[] | null> = ref(null);
    // Use to select item;
    function selectItem(id: number) {
      const hitIndex = selectedItemId.value.indexOf(id);
      if (selectedItemId.value.indexOf(id) > -1) selectedItemId.value.splice(hitIndex, 1);
      else selectedItemId.value.push(id);
      if (selectedItemId.value.length !== purchaseRequestTableData.value.total || selectedPurchaseRequests.value.length === 0) searchValue.value = selectedItemId.value;
      else searchValue.value = 'ALL';
    }
    function clearSelect() {
      selectedItemId.value = [];
      searchValue.value = [];
    }
    function selectAll() {
      forceRender.value = true;
      selectedItemId.value = purchaseRequestTableData.value.data.map((subJob: any) => subJob.id);
      searchValue.value = 'ALL';
      forceRender.value = false;
    }

    // Watch when type of itemsType change
    watch(() => purchaseRequest.value.itemsType, async (newVal, oldVal) => {
      if (newVal !== oldVal && newVal !== '') {
        selectedPurchaseRequests.value = [];
        assignPurchaseRequestToSelectedArrays();
      }
    });
    // Watch when route change;
    watch(() => route.value.params.prId, async (newVal, oldVal) => {
      if (newVal !== oldVal && newVal !== '') {
        await getPurchaseRequestData();
        step.value = 1;
        clearSelect();
        refetchQuery.value = true;
      }
    });
    // Watch when filter was apply
    watch(() => search.filterMaterial, async (newVal, oldVal) => {
      if (newVal !== oldVal) {
        refetchQuery.value = true;
      }
    });
    // Watch when filter was apply
    watch(() => search.filterBomItem, async (newVal, oldVal) => {
      if (newVal !== oldVal) {
        refetchQuery.value = true;
      }
    });

    // use this to manually paginate create pr page;
    const page = ref(1);
    const PERPAGE = 200;
    const createPurchaseOrderPaginator = computed(() => ({
      perPage: PERPAGE,
      total: form[purchaseRequest.value.itemsType === 'MATERIALS' ? 'items' : 'miscItems'].length,
      from: (page.value - 1) * PERPAGE,
      to: (page.value * PERPAGE),
      currentPage: 1,
      lastPage: form[purchaseRequest.value.itemsType === 'MATERIALS' ? 'items' : 'miscItems'].length === 0 ? 1 : Math.ceil(form[purchaseRequest.value.itemsType === 'MATERIALS' ? 'items' : 'miscItems'].length / PERPAGE),
      totalPages: form[purchaseRequest.value.itemsType === 'MATERIALS' ? 'items' : 'miscItems'].length === 0 ? 1 : Math.ceil(form[purchaseRequest.value.itemsType === 'MATERIALS' ? 'items' : 'miscItems'].length / PERPAGE),
    }));
    async function forward() {
      const result = await searchPurchaseRequestItems({ ids: searchValue.value, purchaseRequestIds: computedSelectedPurchaseRequestIds.value }, computedTableInformation.value.type);
      if (purchaseRequest.value.itemsType === 'MATERIALS') {
        form.miscItems = [];
        form.items = result.map((item: any) => ({
          ...item,
          neededAmount: item.amount,
          amount: parseFloat(`${(item.amount - item.filled_amount) > -1 ? (item.amount - item.filled_amount) : 0}`).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
          pricePerUnit: undefined,
          purchaseUnit: item.bom_item.material?.default_purchase_unit || item.bom_item.material?.unit,
          amountPerUnit: 1,
        }));
      } else {
        form.items = [];
        form.miscItems = result.map((item: any) => ({
          ...item,
          neededAmount: item.amount,
          amount: parseFloat(`${(item.amount - item.filled_amount) > -1 ? (item.amount - item.filled_amount) : 0}`).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
          pricePerUnit: undefined,
        }));
      }
      step.value = 2;
    }
    async function backward() {
      step.value = 1;
    }
    const displayData = computed(() => {
      if ((computedTableInformation.value.data as any).length < createPurchaseOrderPaginator.value.to) return (computedTableInformation.value.data as any).slice(createPurchaseOrderPaginator.value.from, (computedTableInformation.value.data as any).length);
      return (computedTableInformation.value.data as any).slice(createPurchaseOrderPaginator.value.from, createPurchaseOrderPaginator.value.to);
    });

    // Hook when CommonRichTableWithAxios finish fetching data;
    // use this to check total record & how many user has select item.
    function receivePurchaseRequestData(data: any) {
      purchaseRequestTableData.value = {
        data: data.data,
        total: data.total,
      };
    }

    // Condition to check form is valid
    const allowedToSubmit = computed(() => {
      if (!(form.supplier)) return false;
      // const pricePerUnitsArr = computedTableInformation.value.data.map((item: any) => parseInt(item.pricePerUnit, 10));
      // if (pricePerUnitsArr.indexOf(0) > -1) return false;
      const amounts = computedTableInformation.value.data.map((item: any) => parseInt(item.amount, 10));
      if (amounts.indexOf(0) > -1) return false;
      return true;
    });

    function pendingToViewPreview() {
      getPreview('purchase_orders/preview', computedPurchaseOrderInput.value, 'Preview Purchase Order', ['miscItems', 'subType']);
    }

    function getMaterialDisplay(mat: any) {
      let output = '';
      if ((mat.name && !(mat.code)) || (mat.code && !(mat.name))) output = `${mat.code || mat.name} ${output}`;
      else if (mat.code && mat.name) output = `${mat.code} - ${mat.name} ${output}`;
      if (mat.brand) output = `[${mat.brand}] ${output}`;
      return output;
    }

    // Check existing Code
    const failedValidatedCodeRule = ref({ excluded: '' });
    const computedCodeInputAsset = computed(() => ({
      rules: failedValidatedCodeRule.value,
    }));
    const pendingCheckExistingPurchaseOrderCode = debounce(async () => {
      const result = form.code ? await checkExistingPurchaseOrderCode(form.code) : { exist: false, latest: '' };

      if (result.exist) failedValidatedCodeRule.value.excluded = form.code || '';
      else failedValidatedCodeRule.value.excluded = '';
    }, 250);

    return {
      NOW,
      toDate,
      typeTranslate,
      getMaterials,
      getMaterialDisplay,

      getSuppliers,
      getSuppliersResult,

      getPurchaseRequests,
      selectedPurchaseRequests,
      computedPurchaseRequestSelectorVariables,

      purchaseRequest,
      forceRender,
      confirmModal,
      step,
      forward,
      backward,

      filter,
      search,
      computedTableInformation,
      refetchQuery,
      selectItem,
      selectedItemId,
      searchValue,

      clearSelect,
      selectAll,
      form,
      allowedToSubmit,

      displayData,
      page,
      pagination: createPurchaseOrderPaginator,

      purchaseRequestTableData,
      receivePurchaseRequestData,

      computedPurchaseOrderPrice,
      computedSupplierAddress,

      pendingToViewPreview,

      computedCodeInputAsset,
      pendingCheckExistingPurchaseOrderCode,
    };
  },
});

export default PanelWithMaterialPurchaseRequestEditor;
